function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.495 10.5259C15.7547 9.37739 17.4583 7.82411 17.6135 4.11328H18.7383V3H4.26562V4.11328H5.39037C5.54564 7.82411 7.24918 9.37739 8.5089 10.5259C9.35391 11.2963 9.83203 11.7679 9.83203 12.5C9.83203 13.2321 9.35391 13.7037 8.5089 14.4741C7.24918 15.6226 5.54564 17.1759 5.39037 20.8867H4.26562V22H18.7383V20.8867H17.6135C17.4583 17.1759 15.7547 15.6226 14.495 14.4741C13.65 13.7037 13.1719 13.2321 13.1719 12.5C13.1719 11.7679 13.65 11.2963 14.495 10.5259ZM10.9453 16.6725C10.7734 16.708 10.6035 16.7596 10.4378 16.8282L7.02827 18.239C7.58506 16.8233 8.48184 16.0053 9.25895 15.2968C10.1262 14.5061 10.9453 13.7593 10.9453 12.5V16.6725ZM13.745 15.2968C14.5221 16.0053 15.4188 16.8233 15.9756 18.239L12.5661 16.8281C12.4004 16.7596 12.2305 16.7079 12.0586 16.6725V12.5C12.0586 13.7593 12.8777 14.5061 13.745 15.2968ZM7.00871 6.71094C6.73956 6.00961 6.55368 5.16281 6.50503 4.11328H16.4988C16.4502 5.16281 16.2643 6.00961 15.9952 6.71094H7.00871Z",
  fill: "#0F2E43"
});

var SvgStatus = function SvgStatus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status.93ec44e1.svg";
export { ForwardRef as ReactComponent };